import { render } from "./accessDenied.vue?vue&type=template&id=82a3b41a"
import script from "./accessDenied.vue?vue&type=script&setup=true&lang=js"
export * from "./accessDenied.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"pages/EndataAuth/Account/App/components/profile/accessDenied.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "82a3b41a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('82a3b41a', __exports__)) {
    api.reload('82a3b41a', __exports__)
  }
  
  module.hot.accept("./accessDenied.vue?vue&type=template&id=82a3b41a", () => {
    api.rerender('82a3b41a', render)
  })

}


export default __exports__